// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_right {
  padding-top: 18px;
  width: 100%;
  padding-right: 30px;
  padding-bottom: 40px;
  padding-left: 30px;
}

.dashboard>.dashboard_right {
  flex: 1 1;
  min-width: 0;
  width: auto;
  max-width: 100%;
}

body.light_theme .dashboard_right {
  background-color: #fff;
  color: #101828;
}


/* ========== SUPPORT PAGE ========== */

.supportsection {
  width: 90%;
  padding-left: 40px;
  padding-top: 10px;
}

.supportsection h4 {
  font-weight: 600;
}

.supportinquery {
  margin-top: 36px;
  width: 70%;
}

.supportinquery .profile_form .emailinput label {
  background-color: #181a20;
}

.supportinquery .profile_form button.submit {
  margin-top: 0px;
}

.supportinquery .profile_form button.submit {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  min-height: 48px;
  border: 0px;
  border-radius: 10px;
  font-size: 16px;
  background-color: #d1aa67;
  color: #ffffff;
  border: none;
  font-weight: 500;
}


/* ========== PROFILE FORM ========== */

form.profile_form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.profile_form .emailinput .d-flex {
  align-items: center;
  gap: 24px;
  justify-content: space-between;
}

.profile_form .emailinput {
  width: 100%;
  position: relative;
  border: 1px solid #949AA4;
  border-radius: 5px;
}

.profile_form .emailinput label {
  color: #949AA4;
  font-size: 12px;
  position: absolute;
  top: -10px;
  left: 24px;
  background-color: #373E4B;
  width: auto;
  padding: 0px 10px;
}

.profile_form .emailinput input {
  font-size: 14px;
  min-height: 50px;
  font-weight: 300;
  background: none;
  border-radius: 0px;
  padding: 10px;
  font-size: 12px;
  color: #fff;
  border: none;
  width: 100%;
}

.profile_form .emailinput textarea {
  font-size: 14px;
  min-height: 50px;
  min-height: 120px;
  font-weight: 300;
  background: none;
  padding: 10px;
  font-size: 12px;
  color: #fff;
  border: none;
  width: 100%;
}

.profile_form .row {
  row-gap: 30px;
}

.profile_form .emailinput select {
  font-size: 14px;
  min-height: 50px;
  font-weight: 300;
  background: none;
  padding: 10px;
  font-size: 12px;
  color: #949AA4;
  border: none;
  width: 100%;
}


/* ========== ISSUE LIST ========== */

.issuelist_data {
  margin-top: 40px;
}

.issuelist_data table tr th {
  font-size: 12px;
  color: #949AA4;
  font-weight: 400;
  border: none;
}

.issuelist_data table tr td {
  border: none;
  font-size: 12px;
  font-weight: 400;
}

.issuelist_data table tr td i.ri-file-copy-line {
  color: #EAECEF;
}

.coin_view_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.coin_view_top h6 {
  font-size: 12px;
  font-weight: 700;
}

.right_t {
  text-align: right !important;
}

.td_first {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
}

button.btn.btn-success {
  color: #fff !important;
  background-color: #5EBA89 !important;
  border-radius: 50px;
  font-size: 12px;
  padding: 3px 16px;
  border-color: #5EBA89;
}

body .text-success {
  color: #5EBA89 !important;
}


/* ========== SEARCH ========== */

.searchBar.custom-tabs {
  background-color: #1f1f1f;
  border: 1px solid #787878;
  padding: 7px 10px;
  font-size: 12px;
  border-radius: 50px;
  gap: 3px;
}

.searchBar.custom-tabs {
  padding: 6px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2B313C;
  border: none;
  font-size: 16px;
  font-weight: 400;
  border-radius: 4px;
  width: 40px;
  transition: 0.5s all;
  overflow: hidden;
}

.searchBar button {
  width: 18px;
  opacity: 0.7;
  background-color: transparent;
  border: transparent;
  padding: 0px;
}

.searchBar button i {
  font-size: 16px;
  color: #fff !important;
  opacity: 1;
}

.searchBar.custom-tabs input {
  font-size: 14px;
  font-weight: 300;
  padding: 0px 10px;
  background: transparent;
  border: 0 !important;
  min-width: min-content;
  width: 100%;
  outline: 0;
}

.searchBar.custom-tabs i {
  cursor: pointer;
}

.searchBar.custom-tabs.search_active {
  width: 320px;
  padding-left: 10px;
}

.searchBar .custom_search {
  display: none;
}

.searchBar.custom-tabs.search_active .custom_search {
  display: block;
}


/* ========== DESKTOP / MOBILE TABLE TOGGLE ========== */

.mobile_view {
  display: none;
}

@media screen and (max-width: 767px) {
  .desktop_view {
    display: none;
  }

  .mobile_view {
    display: block;
  }
}


/* ========== CHAT MODAL ========== */

.modal.search_form {
  border: none;
  padding: 0px;
}

.modal.chatmessages .modal-dialog {
  position: absolute;
  right: 0px;
}

.chatmessages .chat-container {
  height: 700px;
  background: #2F3542;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chatmessages .chat-header {
  background: #2A303C;
  padding: 16px;
  border-bottom: 1px solid #3B4251;
}

.chatmessages .chat-header h3 {
  color: #fff;
  font-size: 18px;
  margin-bottom: 6px;
}

.chatmessages .ticket {
  color: #9AA3B2;
  font-size: 13px;
}

.chatmessages .chat-body {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
}

.chatmessages .message {
  display: flex;
  margin-bottom: 22px;
  align-items: flex-end;
}

.chatmessages .message.right {
  justify-content: flex-end;
}

.chatmessages .avatar {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #4B5160;
  display: flex;
  background-color: #303234;
  align-items: center;
  justify-content: center;
  color: #FFD54F;
  font-weight: bold;
  margin-right: 10px;
}

.chatmessages .message.right .avatar {
  margin-left: 10px;
  margin-right: 0;
}

.chatmessages .bubble {
  max-width: 300px;
  background: #47505E;
  color: #E6E9EF;
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  position: relative;
}

.chatmessages .message.left .bubble::before {
  content: "";
  position: absolute;
  left: -6px;
  bottom: 12px;
  border-width: 6px 6px 6px 0;
  border-style: solid;
  border-color: transparent #47505E transparent transparent;
}

.chatmessages .message.right .bubble::before {
  content: "";
  position: absolute;
  right: -6px;
  bottom: 12px;
  border-width: 6px 0 6px 6px;
  border-style: solid;
  border-color: transparent transparent transparent #3A4151;
}

.chatmessages .chat-footer {
  padding: 14px;
  border-top: 1px solid #3B4251;
  background: #2A303C;
  display: flex;
  align-items: center;
}

.chatmessages .chat-footer input {
  flex: 1 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
}

.chatmessages .chat-footer input::placeholder {
  color: #84888C;
}

.chatmessages .icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #4B5160;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  color: #fff;
  cursor: pointer;
}

.chatmessages .send-btn {
  background: #d1aa67;
  border: none;
  color: #000;
}


/* ========== LIGHT THEME ========== */

body.light_theme .supportinquery .profile_form .emailinput label {
  background-color: #fff;
}

body.light_theme .profile_form .emailinput input {
  color: #9a9a9a;
}

body.light_theme .profile_form .emailinput textarea {
  color: #9a9a9a;
}

body.light_theme .searchBar.custom-tabs {
  background-color: #fff;
}

body.light_theme .searchBar.custom-tabs i {
  color: #000;
}

body.light_theme .searchBar.custom-tabs input {
  color: #000;
}

body.light_theme .issuelist_data table tr td i.ri-file-copy-line {
  color: #a4a4a4;
}

body.light_theme .bg-secondary {
  background-color: rgb(228 228 228) !important;
}

body.light_theme .chatmessages .chat-container {
  background: #fff9f9;
}

body.light_theme .ticket-details {
  background-color: #f3f3f3 !important;
  border-color: #b5b5b554 !important;
}

body.light_theme .chatmessages .chat-header {
  background: #f9f9f9;
  border-bottom: 1px solid #bababa26;
}

body.light_theme .ticket-details span {
  color: #000000f0 !important;
}

body.light_theme .search_form .modal-content {
  background: rgba(255, 255, 255, 0.20);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 10px 30px rgb(0 0 0 / 30%);
}

body.light_theme .chatmessages .chat-header h3 {
  color: #373737;
}

body.light_theme .chatmessages .chat-footer {
  border-top: 1px solid #c7c7c736;
  background: #e4e4e459;
}

.ticket-details.mb-4 {
  background-color: #ffffff14 !important;
}

body.light_theme .modal .btn-close {
  filter: invert(0);
}

body.light_theme .chatmessages .ticket {
  color: #585858;
}

body.light_theme .table> :not(caption)>*>* {
  color: #84878A;
}


/* ========== RESPONSIVE ========== */

@media screen and (max-width: 991px) {
  .supportsection {
    width: 100%;
  }
}

@media screen and (max-width: 767px) {

  .supportinquery {
    width: 100%;
  }

  .supportsection h4 {
    font-size: 18px;
  }

  .supportsection {
    padding-top: 10px;
    padding-left: 0px;
  }

  .supportinquery .profile_form button.submit {
    min-height: 42px;
    font-size: 14px;
  }

  .coin_view_top {
    margin-top: 15px;
  }

  .chatmessages .modal-content {
    padding-bottom: 0px;
  }

  .chatmessages .chat-container {
    border-radius: 0px;
  }

}

@media screen and (max-width: 660px) {
  .Overview_mid .coin_view_top {
    margin-top: 0px;
  }


  body .inngerbox.cng-pass.overflow_unset .mobile_view {
    padding: 10px 0px 5px 0px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Support/Support.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,SAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;;AAGA,uCAAuC;;AAEvC;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;;AAGA,uCAAuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;;AAGA,qCAAqC;;AAErC;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,iCAAiC;;AAEjC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;AAGA,wDAAwD;;AAExD;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;;AAGA,qCAAqC;;AAErC;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;;AAGA,sCAAsC;;AAEtC;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA,qCAAqC;;AAErC;EACE;IACE,WAAW;EACb;AACF;;AAEA;;EAEE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;;EAGA;IACE,yBAAyB;EAC3B;;AAEF","sourcesContent":[".dashboard_right {\n  padding-top: 18px;\n  width: 100%;\n  padding-right: 30px;\n  padding-bottom: 40px;\n  padding-left: 30px;\n}\n\n.dashboard>.dashboard_right {\n  flex: 1 1 0%;\n  min-width: 0;\n  width: auto;\n  max-width: 100%;\n}\n\nbody.light_theme .dashboard_right {\n  background-color: #fff;\n  color: #101828;\n}\n\n\n/* ========== SUPPORT PAGE ========== */\n\n.supportsection {\n  width: 90%;\n  padding-left: 40px;\n  padding-top: 10px;\n}\n\n.supportsection h4 {\n  font-weight: 600;\n}\n\n.supportinquery {\n  margin-top: 36px;\n  width: 70%;\n}\n\n.supportinquery .profile_form .emailinput label {\n  background-color: #181a20;\n}\n\n.supportinquery .profile_form button.submit {\n  margin-top: 0px;\n}\n\n.supportinquery .profile_form button.submit {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  min-height: 48px;\n  border: 0px;\n  border-radius: 10px;\n  font-size: 16px;\n  background-color: #d1aa67;\n  color: #ffffff;\n  border: none;\n  font-weight: 500;\n}\n\n\n/* ========== PROFILE FORM ========== */\n\nform.profile_form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.profile_form .emailinput .d-flex {\n  align-items: center;\n  gap: 24px;\n  justify-content: space-between;\n}\n\n.profile_form .emailinput {\n  width: 100%;\n  position: relative;\n  border: 1px solid #949AA4;\n  border-radius: 5px;\n}\n\n.profile_form .emailinput label {\n  color: #949AA4;\n  font-size: 12px;\n  position: absolute;\n  top: -10px;\n  left: 24px;\n  background-color: #373E4B;\n  width: auto;\n  padding: 0px 10px;\n}\n\n.profile_form .emailinput input {\n  font-size: 14px;\n  min-height: 50px;\n  font-weight: 300;\n  background: none;\n  border-radius: 0px;\n  padding: 10px;\n  font-size: 12px;\n  color: #fff;\n  border: none;\n  width: 100%;\n}\n\n.profile_form .emailinput textarea {\n  font-size: 14px;\n  min-height: 50px;\n  min-height: 120px;\n  font-weight: 300;\n  background: none;\n  padding: 10px;\n  font-size: 12px;\n  color: #fff;\n  border: none;\n  width: 100%;\n}\n\n.profile_form .row {\n  row-gap: 30px;\n}\n\n.profile_form .emailinput select {\n  font-size: 14px;\n  min-height: 50px;\n  font-weight: 300;\n  background: none;\n  padding: 10px;\n  font-size: 12px;\n  color: #949AA4;\n  border: none;\n  width: 100%;\n}\n\n\n/* ========== ISSUE LIST ========== */\n\n.issuelist_data {\n  margin-top: 40px;\n}\n\n.issuelist_data table tr th {\n  font-size: 12px;\n  color: #949AA4;\n  font-weight: 400;\n  border: none;\n}\n\n.issuelist_data table tr td {\n  border: none;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.issuelist_data table tr td i.ri-file-copy-line {\n  color: #EAECEF;\n}\n\n.coin_view_top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.coin_view_top h6 {\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.right_t {\n  text-align: right !important;\n}\n\n.td_first {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 400;\n}\n\nbutton.btn.btn-success {\n  color: #fff !important;\n  background-color: #5EBA89 !important;\n  border-radius: 50px;\n  font-size: 12px;\n  padding: 3px 16px;\n  border-color: #5EBA89;\n}\n\nbody .text-success {\n  color: #5EBA89 !important;\n}\n\n\n/* ========== SEARCH ========== */\n\n.searchBar.custom-tabs {\n  background-color: #1f1f1f;\n  border: 1px solid #787878;\n  padding: 7px 10px;\n  font-size: 12px;\n  border-radius: 50px;\n  gap: 3px;\n}\n\n.searchBar.custom-tabs {\n  padding: 6px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #2B313C;\n  border: none;\n  font-size: 16px;\n  font-weight: 400;\n  border-radius: 4px;\n  width: 40px;\n  transition: 0.5s all;\n  overflow: hidden;\n}\n\n.searchBar button {\n  width: 18px;\n  opacity: 0.7;\n  background-color: transparent;\n  border: transparent;\n  padding: 0px;\n}\n\n.searchBar button i {\n  font-size: 16px;\n  color: #fff !important;\n  opacity: 1;\n}\n\n.searchBar.custom-tabs input {\n  font-size: 14px;\n  font-weight: 300;\n  padding: 0px 10px;\n  background: transparent;\n  border: 0 !important;\n  min-width: min-content;\n  width: 100%;\n  outline: 0;\n}\n\n.searchBar.custom-tabs i {\n  cursor: pointer;\n}\n\n.searchBar.custom-tabs.search_active {\n  width: 320px;\n  padding-left: 10px;\n}\n\n.searchBar .custom_search {\n  display: none;\n}\n\n.searchBar.custom-tabs.search_active .custom_search {\n  display: block;\n}\n\n\n/* ========== DESKTOP / MOBILE TABLE TOGGLE ========== */\n\n.mobile_view {\n  display: none;\n}\n\n@media screen and (max-width: 767px) {\n  .desktop_view {\n    display: none;\n  }\n\n  .mobile_view {\n    display: block;\n  }\n}\n\n\n/* ========== CHAT MODAL ========== */\n\n.modal.search_form {\n  border: none;\n  padding: 0px;\n}\n\n.modal.chatmessages .modal-dialog {\n  position: absolute;\n  right: 0px;\n}\n\n.chatmessages .chat-container {\n  height: 700px;\n  background: #2F3542;\n  border-radius: 14px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.chatmessages .chat-header {\n  background: #2A303C;\n  padding: 16px;\n  border-bottom: 1px solid #3B4251;\n}\n\n.chatmessages .chat-header h3 {\n  color: #fff;\n  font-size: 18px;\n  margin-bottom: 6px;\n}\n\n.chatmessages .ticket {\n  color: #9AA3B2;\n  font-size: 13px;\n}\n\n.chatmessages .chat-body {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.chatmessages .message {\n  display: flex;\n  margin-bottom: 22px;\n  align-items: flex-end;\n}\n\n.chatmessages .message.right {\n  justify-content: flex-end;\n}\n\n.chatmessages .avatar {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid #4B5160;\n  display: flex;\n  background-color: #303234;\n  align-items: center;\n  justify-content: center;\n  color: #FFD54F;\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.chatmessages .message.right .avatar {\n  margin-left: 10px;\n  margin-right: 0;\n}\n\n.chatmessages .bubble {\n  max-width: 300px;\n  background: #47505E;\n  color: #E6E9EF;\n  padding: 14px 16px;\n  border-radius: 12px;\n  font-size: 14px;\n  line-height: 1.5;\n  position: relative;\n}\n\n.chatmessages .message.left .bubble::before {\n  content: \"\";\n  position: absolute;\n  left: -6px;\n  bottom: 12px;\n  border-width: 6px 6px 6px 0;\n  border-style: solid;\n  border-color: transparent #47505E transparent transparent;\n}\n\n.chatmessages .message.right .bubble::before {\n  content: \"\";\n  position: absolute;\n  right: -6px;\n  bottom: 12px;\n  border-width: 6px 0 6px 6px;\n  border-style: solid;\n  border-color: transparent transparent transparent #3A4151;\n}\n\n.chatmessages .chat-footer {\n  padding: 14px;\n  border-top: 1px solid #3B4251;\n  background: #2A303C;\n  display: flex;\n  align-items: center;\n}\n\n.chatmessages .chat-footer input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #fff;\n  font-size: 14px;\n}\n\n.chatmessages .chat-footer input::placeholder {\n  color: #84888C;\n}\n\n.chatmessages .icon-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #4B5160;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 10px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.chatmessages .send-btn {\n  background: #d1aa67;\n  border: none;\n  color: #000;\n}\n\n\n/* ========== LIGHT THEME ========== */\n\nbody.light_theme .supportinquery .profile_form .emailinput label {\n  background-color: #fff;\n}\n\nbody.light_theme .profile_form .emailinput input {\n  color: #9a9a9a;\n}\n\nbody.light_theme .profile_form .emailinput textarea {\n  color: #9a9a9a;\n}\n\nbody.light_theme .searchBar.custom-tabs {\n  background-color: #fff;\n}\n\nbody.light_theme .searchBar.custom-tabs i {\n  color: #000;\n}\n\nbody.light_theme .searchBar.custom-tabs input {\n  color: #000;\n}\n\nbody.light_theme .issuelist_data table tr td i.ri-file-copy-line {\n  color: #a4a4a4;\n}\n\nbody.light_theme .bg-secondary {\n  background-color: rgb(228 228 228) !important;\n}\n\nbody.light_theme .chatmessages .chat-container {\n  background: #fff9f9;\n}\n\nbody.light_theme .ticket-details {\n  background-color: #f3f3f3 !important;\n  border-color: #b5b5b554 !important;\n}\n\nbody.light_theme .chatmessages .chat-header {\n  background: #f9f9f9;\n  border-bottom: 1px solid #bababa26;\n}\n\nbody.light_theme .ticket-details span {\n  color: #000000f0 !important;\n}\n\nbody.light_theme .search_form .modal-content {\n  background: rgba(255, 255, 255, 0.20);\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  box-shadow: 0 10px 30px rgb(0 0 0 / 30%);\n}\n\nbody.light_theme .chatmessages .chat-header h3 {\n  color: #373737;\n}\n\nbody.light_theme .chatmessages .chat-footer {\n  border-top: 1px solid #c7c7c736;\n  background: #e4e4e459;\n}\n\n.ticket-details.mb-4 {\n  background-color: #ffffff14 !important;\n}\n\nbody.light_theme .modal .btn-close {\n  filter: invert(0);\n}\n\nbody.light_theme .chatmessages .ticket {\n  color: #585858;\n}\n\nbody.light_theme .table> :not(caption)>*>* {\n  color: #84878A;\n}\n\n\n/* ========== RESPONSIVE ========== */\n\n@media screen and (max-width: 991px) {\n  .supportsection {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 767px) {\n\n  .supportinquery {\n    width: 100%;\n  }\n\n  .supportsection h4 {\n    font-size: 18px;\n  }\n\n  .supportsection {\n    padding-top: 10px;\n    padding-left: 0px;\n  }\n\n  .supportinquery .profile_form button.submit {\n    min-height: 42px;\n    font-size: 14px;\n  }\n\n  .coin_view_top {\n    margin-top: 15px;\n  }\n\n  .chatmessages .modal-content {\n    padding-bottom: 0px;\n  }\n\n  .chatmessages .chat-container {\n    border-radius: 0px;\n  }\n\n}\n\n@media screen and (max-width: 660px) {\n  .Overview_mid .coin_view_top {\n    margin-top: 0px;\n  }\n\n\n  body .inngerbox.cng-pass.overflow_unset .mobile_view {\n    padding: 10px 0px 5px 0px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
